import { Icon } from '@a-ui/react';

const Location = (props) => {
  const noLocation = <>
    <Icon name="ai-pin" className="u-margin-right-xxs"/>
    <span className="u-text-light">Niet gespecifieerd</span>
  </>;

  if (!props.location) return noLocation;

  const { street, streetNumber, postalCode, friendlyName, xCoordinate, yCoordinate } = props.location;
  if ((!street || street === "") && (!xCoordinate || !yCoordinate)) {
    if (friendlyName !== "") {
      return <>
        <Icon name="ai-pin" className="u-margin-right-xxs"/>
        <span className="u-text-light">{friendlyName}</span>
      </>;
    }
    return noLocation
  }
  const adres = street && streetNumber && postalCode ? `${street} ${streetNumber} ${postalCode}` : friendlyName;
  return <>
    <Icon name="ai-pin" className="u-m u-margin-right-xxs"/>
    <a target="_blank" rel="noreferrer" href={`https://www.google.com/maps/dir/?api=1&destination=${xCoordinate},${yCoordinate}&dir_action=navigate&travelmode=driving`}>{adres}</a>
  </>
}

export default Location;
